import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { SlidersHorizontal } from "lucide-react";

export default function Category() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [products, setProducts] = useState([]);
  const [sort, setSort] = useState("newest");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/categories").then((r) => setCat(r.data.find((c) => c.slug === slug) || null));
    api.get("/products", { params: { category: slug, sort, limit: 48 } })
      .then((r) => setProducts(r.data.items))
      .finally(() => setLoading(false));
  }, [slug, sort]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <nav className="text-xs text-[#8C7A80] mb-4">
        <Link to="/" className="hover:text-[#C9708B]">Início</Link> / <span className="text-[#C9708B]">{cat?.name || slug}</span>
      </nav>
      <div className="flex items-end justify-between mb-6">
        <div>
          <h1 className="font-serif font-bold text-[#4A3B40] text-3xl sm:text-4xl">{cat?.name || slug}</h1>
          <p className="text-[#8C7A80] text-sm mt-1">{products.length} produtos</p>
        </div>
        <div className="flex items-center gap-2 bg-white border border-[#F9E1E8] rounded-full px-4 py-2">
          <SlidersHorizontal className="w-4 h-4 text-[#8C7A80]" />
          <select
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="bg-transparent text-sm outline-none text-[#4A3B40]"
            data-testid="sort-select"
          >
            <option value="newest">Novidades</option>
            <option value="bestseller">Mais vendidos</option>
            <option value="price_asc">Menor preço</option>
            <option value="price_desc">Maior preço</option>
          </select>
        </div>
      </div>
      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {Array.from({length:8}).map((_,i)=> <div key={i} className="aspect-[3/4] bg-white rounded-2xl border border-[#F9E1E8] animate-pulse" />)}
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 text-[#8C7A80]">Nenhum produto encontrado nesta categoria.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="category-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
